import { render, staticRenderFns } from "./Bedankt.vue?vue&type=template&id=496e1e44&scoped=true&"
import script from "./Bedankt.vue?vue&type=script&lang=js&"
export * from "./Bedankt.vue?vue&type=script&lang=js&"
import style0 from "./Bedankt.vue?vue&type=style&index=0&id=496e1e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e1e44",
  null
  
)

export default component.exports